(function () {
  if (window.rathnaDeliveryTimelineBound) return;
  window.rathnaDeliveryTimelineBound = true;

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function formatDay(date) {
    return MONTHS[date.getMonth()] + ' ' + date.getDate();
  }

  function addDays(base, days) {
    var d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    d.setDate(d.getDate() + days);
    return d;
  }

  function rangeLabel(start, end) {
    if (start.getTime() === end.getTime()) return formatDay(start);
    if (start.getMonth() === end.getMonth()) {
      return MONTHS[start.getMonth()] + ' ' + start.getDate() + ' – ' + end.getDate();
    }
    return formatDay(start) + ' – ' + formatDay(end);
  }

  function classifyPincode(pin) {
    if (!/^\d{6}$/.test(pin)) return null;
    var n = parseInt(pin, 10);
    var p2 = Math.floor(n / 10000);
    var p3 = Math.floor(n / 1000);

    // Chennai city + common suburbs
    if (p3 === 600 || p3 === 601 || p3 === 602 || p3 === 603) return 'chennai';

    // Tamil Nadu (60–64)
    if (p2 >= 60 && p2 <= 64) return 'tamil_nadu';

    // Major metro first-two-digit ranges
    var metros = {
      11: true, // Delhi
      12: true, // NCR
      13: true,
      14: true,
      16: true, // Chandigarh
      22: true, // Lucknow
      30: true, // Jaipur
      38: true, // Ahmedabad
      40: true, // Mumbai
      41: true, // Pune
      50: true, // Hyderabad
      56: true, // Bengaluru
      70: true, // Kolkata
      78: true  // Guwahati (often treated express in some networks; keep as metro optional)
    };
    if (metros[p2]) return 'metro';

    return 'other';
  }

  function buildSteps(zone) {
    var today = new Date();
    var placed = today;
    var shipStart;
    var shipEnd;
    var delStart;
    var delEnd;
    var zoneLabel;

    switch (zone) {
      case 'chennai':
        zoneLabel = 'Within Chennai — next-day delivery (24 hours)';
        shipStart = addDays(today, 0);
        shipEnd = addDays(today, 1);
        delStart = addDays(today, 1);
        delEnd = addDays(today, 1);
        break;
      case 'tamil_nadu':
        zoneLabel = 'Within Tamil Nadu — 2 days';
        shipStart = addDays(today, 1);
        shipEnd = addDays(today, 1);
        delStart = addDays(today, 2);
        delEnd = addDays(today, 2);
        break;
      case 'metro':
        zoneLabel = 'Metro city — 2 days (Express Shipping)';
        shipStart = addDays(today, 1);
        shipEnd = addDays(today, 1);
        delStart = addDays(today, 2);
        delEnd = addDays(today, 2);
        break;
      default:
        zoneLabel = 'Other states — 4–7 days';
        shipStart = addDays(today, 2);
        shipEnd = addDays(today, 3);
        delStart = addDays(today, 4);
        delEnd = addDays(today, 7);
        break;
    }

    return {
      zoneLabel: zoneLabel,
      steps: [
        { key: 'placed', title: 'Order Placed', date: formatDay(placed) },
        { key: 'shipping', title: 'Shipping', date: rangeLabel(shipStart, shipEnd) },
        { key: 'delivered', title: 'Delivered', date: rangeLabel(delStart, delEnd) }
      ]
    };
  }

  document.addEventListener('alpine:init', function () {
    Alpine.data('xRathnaDeliveryTimeline', function () {
      return {
        pincode: '',
        loading: false,
        error: '',
        zoneLabel: '',
        steps: [],
        init: function () {
          try {
            var saved = localStorage.getItem('customerPincode') || localStorage.getItem('rathnaDeliveryPincode');
            if (saved && /^\d{6}$/.test(saved)) {
              this.pincode = saved;
              this.check(true);
            }
          } catch (e) {}
        },
        check: function (silent) {
          var pin = String(this.pincode || '').replace(/\D/g, '').slice(0, 6);
          this.pincode = pin;
          this.error = '';
          if (pin.length !== 6) {
            this.steps = [];
            this.zoneLabel = '';
            if (!silent) this.error = 'Enter a valid 6-digit pincode';
            return;
          }
          var zone = classifyPincode(pin);
          if (!zone) {
            this.steps = [];
            this.zoneLabel = '';
            this.error = 'Enter a valid 6-digit pincode';
            return;
          }
          this.loading = true;
          var result = buildSteps(zone);
          this.zoneLabel = result.zoneLabel;
          this.steps = result.steps;
          this.loading = false;
          try {
            localStorage.setItem('rathnaDeliveryPincode', pin);
            localStorage.setItem('customerPincode', pin);
          } catch (e) {}
          if (window.Alpine && Alpine.store('xStoreSelector') && typeof Alpine.store('xStoreSelector').syncPincodeAttribute === 'function') {
            try {
              Alpine.store('xStoreSelector').syncPincodeAttribute(pin);
            } catch (e) {}
          }
        }
      };
    });
  });
})();
